import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=278bcf44&scoped=true&"
import script from "./PostList.vue?vue&type=script&lang=ts&"
export * from "./PostList.vue?vue&type=script&lang=ts&"
import style0 from "./PostList.vue?vue&type=style&index=0&id=278bcf44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bcf44",
  null
  
)

export default component.exports